import {NS} from 'entities/Car'
import {EMPTY_CAR_BODY_TYPE} from "../../Administration/lib/constants";
export const SAMPLE_GENERATIONS: NS.IGeneration[] = [
    {
        id: 0,
        variants: [
            {
                id: 0,
                photo: null,
                car_body_type: EMPTY_CAR_BODY_TYPE
            },
            {
                id: 0,
                photo: null,
                car_body_type: EMPTY_CAR_BODY_TYPE
            },
            {
                id: 0,
                photo: null,
                car_body_type: EMPTY_CAR_BODY_TYPE
            }
        ],
        start_date: '',
        end_date: '',
        name: ''
    },
    {
        id: 0,
        variants: [
            {
                id: 0,
                photo: null,
                car_body_type: EMPTY_CAR_BODY_TYPE
            },
            {
                id: 0,
                photo: null,
                car_body_type: EMPTY_CAR_BODY_TYPE
            },
            {
                id: 0,
                photo: null,
                car_body_type: EMPTY_CAR_BODY_TYPE
            }
        ],
        start_date: '',
        end_date: '',
        name: ''
    }
]